import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ProfileIcon from "../SVGComponents/ProfileIcon";
import { isHandheld } from "../App/utils";

const ProfileButton = ({ customerObj, loggedIn, profileButtonAction }) => {
  const [isInHandheldView, setIsHandheld] = useState(isHandheld());

  useEffect(() => {
    const updateDimensions = () => {
      setIsHandheld(isHandheld());
    };

    updateDimensions();
    window.addEventListener("resize", updateDimensions);

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  });

  return (
    <button
      data-quid="profile-button"
      className="sub-navigation__item sub-navigation__item--login"
      onClick={isInHandheldView && loggedIn ? null : profileButtonAction}
    >
      <ProfileIcon />
      {loggedIn ? (
        <div data-quid="sign-out">
          <p className="button--mobile">Hi, {customerObj.FirstName}</p>
          <p className="button--desktop">Sign Out</p>
        </div>
      ) : (
        <div data-quid="sign-in">
          <p className="button--mobile">Sign In</p>
          <p className="button--desktop">Sign In</p>
        </div>
      )}
    </button>
  );
};

ProfileButton.propTypes = {
  loggedIn: PropTypes.bool,
  customerObj: PropTypes.shape({
    FirstName: PropTypes.string
  }),
  profileButtonAction: PropTypes.func.isRequired
};

ProfileButton.defaultProps = {
  loggedIn: null,
  customerObj: {
    FirstName: "Maverick"
  }
};

export default ProfileButton;
